/**
 * Return the direction of the given line.
 *
 * @param {line3} line - the line for reference
 * @return {vec3} the relative vector in the direction of the line
 * @alias module:modeling/maths/line3.direction
 */
const direction = (line) => line[1]

module.exports = direction
